import React from "react";
import T from "prop-types";

function FormLink({ children, label, addons = [] }) {
  return [
    <label className="control-label" htmlFor={label}>
      {label.toUpperCase()}
      {addons}
    </label>,
    <div className="input-group full-width">
      <span className="form-control" disabled>
        {children}
      </span>
    </div>
  ];
}

FormLink.propTypes = {
  label: T.string,
  children: T.oneOfType([T.node, T.arrayOf(T.node)])
};

export default FormLink;



// WEBPACK FOOTER //
// ./app/modules/shared/components/Forms/FormLink/FormLink.jsx